
"use client";

import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Buttons } from "../../../../components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useColor } from "../../../../components/ui/ColorContext";
import ColorPicker from "../../../../components/ui/ColorPicker";
import { Dialog, DialogContent, DialogTrigger } from "../../../../components/ui/dialog";
import { Slider } from "../../../../components/ui/slider";
import { ProfileContext } from "../EntirePreview";
import { ScoreContext } from "../GamePreview";
import { storeReflection } from "utils/gameApplication/gamePlayService";
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { updateScreenActivity } from "../common";
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187";
  return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
};

interface ReflectionFutureThemeProps {
  formData?: any;
  reflectionQuestions?: any;
  imageSrc?: any;
  gameInfo?: any;
  setCurrentScreenId?: any;
  preloadedAssets?: any;
  FeedbackcurrentPosition?: any;
  setFeedbackCurrentPosition?: any;
  interactionBlockArray?: any;
  profileData?: any;
  feedbackList?: any;
  getFeedbackData?: () => void;
  setInterActionBlockArray?: any;
  setFeedbackNavigateNext?: any;
  setCurrentQuestNo?: any;
  setFirstLoading?: any;
  learnerPlayList?: any;
  setLearnerPlayingDetails?: any;
}

const ReflectionFutureTheme: React.FC<ReflectionFutureThemeProps> = ({
  formData = {},
  reflectionQuestions = [],
  imageSrc = '',
  gameInfo = {},
  setCurrentScreenId = () => {},
  preloadedAssets = {},
  FeedbackcurrentPosition = 0,
  setFeedbackCurrentPosition = () => {},
  interactionBlockArray = [],
  profileData = {},
  feedbackList = [],
  getFeedbackData = () => {},
  setInterActionBlockArray = () => {},
  setFeedbackNavigateNext = () => {},
  setCurrentQuestNo = () => {},
  setFirstLoading = () => {},
  learnerPlayList = {},
  setLearnerPlayingDetails = () => {},
}) => {
  // ========== ALL LOGIC FROM OLD CODE ==========
  const { deviceInfo,
      setlearnerActivityrec} = useContext(ScoreContext);
  const useData = useContext(ProfileContext);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [answers, setAnswers] = useState<any>([]);
  const [RefAnswer, setrefAnswer] = useState<any>([]);
  const [reflectionFilter, setReflectionFilter] = useState<any>([reflectionQuestions]);
  const { id } = useParams();
  const Gameid = id ? id : null;
  const scoreContext = useContext(ScoreContext);
  const profile = scoreContext?.profile || { currentQuest: '1' };
  const setProfile = scoreContext?.setProfile || (() => {});
  const playingQuestNo = learnerPlayList?.PlayerScore_Level?.currentQuest;
  const playingGameId = learnerPlayList?.GameId;
   const playClickSound = () => {
          try {
            const audio = new Audio(BtnClickSound as string);
            audio.volume = 1;
            audio.play().catch(() => { });
    
            setTimeout(() => {
              audio.pause();
              audio.currentTime = 0;
            }, 1000);
          } catch (e) {
            // ignore audio errors
          }
        };
  // ========== EXACT SAME LOGIC FUNCTIONS FROM OLD CODE ==========
  const StroredAnsRefLang = () => {
    const storedRefAnswers = learnerPlayList?.playerInputs?.Refelection_Answer || [];
    if (storedRefAnswers !== undefined) {
      setrefAnswer(storedRefAnswers);
      const modifedAnswers = storedRefAnswers.map((item: { [key: string]: string }) => {
        const key = Object.keys(item)[0];
        return { text: item[key] };
      });
      setAnswers(modifedAnswers);
    }
    if (reflectionQuestions && reflectionQuestions.length > 0) {
      const translationId = 1;
      const ReflectionFilter = reflectionQuestions.filter((item: any, index: number) => 
        (item?.translationId === translationId)
      );
      if (ReflectionFilter.length === (formData?.gameReflectionQuestion || ReflectionFilter.length)) {
        setReflectionFilter(ReflectionFilter);
      } else {
        const requiredQuestions = ReflectionFilter.slice(0, formData?.gameReflectionQuestion || ReflectionFilter.length);
        setReflectionFilter(requiredQuestions);
      }
    }
  };

  useEffect(() => {
    StroredAnsRefLang();
  }, []);

  const validateFunc = () => {
    if (
      formData?.gameIsLearnerMandatoryQuestion &&
      formData?.gameReflectionQuestion &&
      answers.length === formData?.gameReflectionQuestion
    ) {
      let validate = answers?.filter((ans: any) => ans === undefined || !ans.text || ans.text.trim() === '');
      validate.length === 0 ? setIsFormValid(true) : setIsFormValid(false);
    } else {
      formData?.gameIsLearnerMandatoryQuestion === "true"
        ? setIsFormValid(false)
        : setIsFormValid(true);
    }
  };

  useEffect(() => {
    validateFunc();
  }, [answers]);

  useEffect(() => {
    StroredAnsRefLang();
  }, [reflectionQuestions]);

  const updateAnswer = (e: any, index: any) => {
    const ansValue = e.target.value;

    const updatedAnswers = [...answers];
    updatedAnswers[index] = { ...updatedAnswers[index], text: e.target.value };
    const updatedRefAnswers = [...RefAnswer];
    updatedRefAnswers[index] = { ...updatedRefAnswers[index], [`ref${index + 1}`]: e.target.value };
    setAnswers(updatedAnswers);
    setrefAnswer(updatedRefAnswers);
  };

  const nextNavigation = async () => {
      playClickSound();
    if (!isFormValid && formData?.gameIsLearnerMandatoryQuestion === "true") {
      return false;
    }

    setFirstLoading(true);

    setLearnerPlayingDetails((prev: any) => ({
      ...prev,
      playerInputs: {
        ...prev.playerInputs,
        Refelection_Answer: RefAnswer,
      }
    }));
    setlearnerActivityrec((prev:any)=>
      updateScreenActivity(
        prev,
        3,
        "Reflection",
        deviceInfo,
        {
          ref_answer:RefAnswer,
        }
      )
    );
    const data = {
      answers: RefAnswer,
      gameId: playingGameId,
      questNo: playingQuestNo,
      refansGameMode: 'game'
    };

    try {
      const result = await storeReflection(JSON.stringify(data));
      if (result.status === 'Success') {
        if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
          setCurrentScreenId(7);
        } else {
          setCurrentScreenId(5);
        }
      }
    } catch (error) {
      console.error('Error saving reflection:', error);
    }
  };

  const backNavigation = () => {
      playClickSound();
    const LastquestNo = parseInt(profile.currentQuest) || 1;
    setFirstLoading(false);
    setCurrentQuestNo(LastquestNo);

    if (feedbackList && feedbackList.length !== 0 && gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion') {
      if (feedbackList?.find((item: any) => item.quest == profile.currentQuest)) {
        const groupedFeedback: { [key: string]: any[] } = {};
        feedbackList.forEach((feedback: any) => {
          if (!(feedback.Seq in groupedFeedback)) {
            groupedFeedback[feedback.Seq] = [];
          }
          groupedFeedback[feedback.Seq].push(feedback);
        });
        const firstPageFeedback: any[] = [];
        Object.keys(groupedFeedback).forEach((seq: any) => {
          const lastIndex = groupedFeedback[seq].length - 1;
          if (profile.currentQuest == groupedFeedback[seq][lastIndex].quest) {
            firstPageFeedback.push(groupedFeedback[seq][lastIndex]);
          }
        });
        setFeedbackCurrentPosition(firstPageFeedback.length - 1);
        setInterActionBlockArray(firstPageFeedback.length - 1);
        getFeedbackData();
        setFeedbackNavigateNext(false);
        setCurrentScreenId(14);
      } else if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
        setCurrentScreenId(4);
        return false;
      } else {
        setCurrentScreenId(6);
        return false;
      }
    } else if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
      setCurrentScreenId(4);
      return false;
    } else {
      setCurrentScreenId(6);
      return false;
    }
  };

  useEffect(() => {
    if (formData?.gameIsLearnerMandatoryQuestion === 'false') {
      setIsFormValid(true);
    } else {
      validateFunc();
    }
    StroredAnsRefLang();
  }, [formData]);

  // ========== NEW THEME UI ==========
  const { primaryColor } = useColor();

  // If reflection is disabled
  if (formData?.gameIsShowReflectionScreen !== 'true') {
    return (
      <div className="relative w-full h-screen overflow-hidden bg-black/90 flex items-center justify-center">
        <div 
          className="text-center max-w-md p-8 rounded-2xl backdrop-blur-lg"
          style={{
            background: `linear-gradient(21deg, rgba(${hexToRgb(
              primaryColor
            )}, 0.05) -10.76%, rgba(${hexToRgb(primaryColor)}, 0.1) 127.18%)`,
            border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.3)`,
          }}
        >
          <h2 className="text-2xl mb-4 text-white">Reflection Disabled</h2>
          <p className="text-gray-300 mb-8">
            The "Show Reflection" option is currently disabled. Please enable it if you want to use this feature.
          </p>
          <div className="flex justify-between w-full px-4">
            <Buttons
              onClick={backNavigation}
              className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl"
              style={{
                background: `linear-gradient(275.041deg, rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%)`,
                border: `1px solid ${primaryColor}`,
              }}
            >
              <ChevronLeft className="!h-4 !w-4 text-white" />
            </Buttons>
            <Buttons
              onClick={nextNavigation}
              className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl"
              style={{
                background: `linear-gradient(90deg, rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%)`,
                border: `1px solid ${primaryColor}`,
              }}
            >
              <ChevronRight className="!h-4 !w-4 text-white" />
            </Buttons>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black/90">
      {/* Background Image */}
      {imageSrc && formData?.gameIsShowReflectionScreen === 'true' && (
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-50"
          // style={{ backgroundImage: `url(${imageSrc})` }}
        />
      )}

     
    

      {/* Reflection Content */}
      <div className="h-full flex-grow flex flex-col justify-center items-center ">
          <div
            // className="flex flex-col gap-5 max-h-fit max-w-fit overflow-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-10 py-8 backdrop-filter backdrop-blur-[3.724rem]"
     
className="  flex flex-col gap-5 max-h-fit overflow-hidden h-full
             
  items-center justify-start rounded-[2.375rem] relative px-6 sm:px-8 md:px-10 py-8
  backdrop-filter backdrop-blur-[3.724rem]
"

            style={{
              background: `linear-gradient(21deg, rgba(${hexToRgb(
                primaryColor
              )}, 0.05) -10.76%, rgba(${hexToRgb(primaryColor)}, 0.1) 127.18%)`,
            }}
          >
          {/* Reflection Title */}
          <div className="relative">
            <h1
              className="text-4xl font-normal tracking-[0.005rem] text-center"
              style={{
                color: primaryColor,
                textShadow: `rgba(${hexToRgb(primaryColor)}, 0.5) 0px 0px 9px`,
              }}
            >
              Reflection
            </h1>
          </div>

          {/* Decorative Line */}
          <div className="flex items-center justify-center relative w-full">
            <div className="w-full">
              <div className="h-[1px] relative w-full">
                <div
                  className="absolute inset-0"
                  style={{
                    background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                    opacity: 0.995,
                  }}
                />
              </div>
            </div>
          </div>

          {/* Questions Grid */}
          <div className="flex-1 w-full flex justify-center px-3 py-4 overflow-y-auto">
            <div className="w-full max-w-[75rem] mx-auto">
              <div className="relative">
                {/* <div className={`grid ${formData?.gameReflectionQuestion === 1 ? 'grid-cols-1' : 'grid-cols-1 lg:grid-cols-2'} gap-x-[3rem] gap-y-[2.5rem] lg:gap-x-[2.5rem] lg:gap-y-[2rem] place-items-center`}> */}
                <div
  className={`grid ${
    formData?.gameReflectionQuestion === 1
      ? 'grid-cols-1 md:grid-cols-1'
      : 'grid-cols-1 md:grid-cols-1 lg:grid-cols-2'
  } gap-x-[3rem] gap-y-[2.5rem] lg:gap-x-[2.5rem] lg:gap-y-[2rem] place-items-center`}
>

                  {reflectionFilter.map((question: any, index: number) => (
                    <div key={index} className="w-full flex justify-center">
                      <div className="flex flex-col gap-2 w-full max-w-[35rem]">
                        {/* Question Header */}
                        <div className="box-border content-stretch flex flex-col sm:flex-row gap-2 items-start sm:items-center justify-start leading-[0] p-0 relative shrink-0 text-white">
                          <div className="box-border content-stretch flex flex-row gap-1 items-end justify-start not-italic p-0 relative shadow-[0px_0.993px_3.973px_0px_rgba(0,0,0,0.25)] shrink-0 tracking-[-0.0935px]">
                            <div
                              className="[text-shadow:rgba(0,0,0,0.46)_0px_7.482px_18.175px] flex flex-col h-[1.152rem] justify-center relative shrink-0 text-xl w-4 text-white"
                            >
                              <p className="adjustLetterSpacing block leading-[4.793rem]">Q</p>
                            </div>
                            <div
                              className="[text-shadow:rgba(0,0,0,0.46)_0px_7.482px_18.175px] flex flex-col h-[1.152rem] justify-center relative shrink-0 text-xl w-3 text-white"
                            >
                              <p className="adjustLetterSpacing block leading-[4.793rem]">
                                {/* {index + 1} */}
                                s
                              </p>
                            </div>
                          </div>
                          <div className="flex flex-col font-rubik font-normal justify-center relative shrink-0 text-lg sm:text-xl tracking-[-0.09px] max-w-full">
                            <p className="adjustLetterSpacing block leading-[1.8rem] sm:leading-[2.15rem] break-words text-white">
                              {question?.refQuestion || `Question ${index + 1}`}
                            </p>
                          </div>
                        </div>

                        {/* Textarea Container */}
                        <div
                          className="relative rounded-3xl overflow-hidden shrink-0 w-full min-w-[28rem]"
                          style={{
                            border: `1.433px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                            background: `linear-gradient(21deg, rgba(10, 10, 10, 0.70) -10.76%, rgba(${hexToRgb(
                              primaryColor
                            )}, 0.1) 127.18%)`,
                          }}
                        >
                          <div className="p-4">
                            <textarea
                              // className="w-full min-h-[4.5rem] bg-transparent border-none resize-none text-white placeholder:text-gray-400 focus:ring-0 focus:outline-none"
                               className="w-full h-[6rem] bg-transparent border-none resize-none text-white placeholder:text-gray-400 focus:ring-0 focus:outline-none"
                              placeholder="Enter your answer here"
                              rows={5}
                              value={answers[index]?.text || ''}
                              onChange={(e) => updateAnswer(e, index)}
                     style={{
                      background: "transparent",
                    }}
                          
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Navigation */}
          <div className="flex justify-between items-center w-full">
            <Buttons
              onClick={backNavigation}
              className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl"
              style={{
                background: `linear-gradient(275.041deg, rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%)`,
                border: `1px solid ${primaryColor}`,
              }}
            >
              <ChevronLeft className="!h-4 !w-4 text-white" />
            </Buttons>
            <Buttons
              onClick={nextNavigation}
              disabled={!isFormValid}
              className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                background: `linear-gradient(90deg, rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%)`,
                border: `1px solid ${primaryColor}`,
              }}
            >
              <ChevronRight className="!h-4 !w-4 text-white" />
            </Buttons>
          </div>

               <div className="absolute h-[25rem] w-[30.75rem] -top-[5rem] -right-[5rem] mix-blend-exclusion opacity-20 pointer-events-none">
              <div
                className="absolute inset-0 rounded-full blur-[9.375rem]"
                style={{
                  background: primaryColor,
                  transform: "scale(0.8)",
                }}
              />
            </div>
            <div className="absolute h-[25rem] w-[30.75rem] -top-[7.5rem] -left-[5rem] mix-blend-exclusion opacity-15 pointer-events-none">
              <div
                className="absolute inset-0 rounded-full blur-[9.375rem]"
                style={{
                  background: primaryColor,
                  transform: "scale(0.8)",
                }}
              />
            </div>
        </div>
      </div>
    </div>
  );
};

export default ReflectionFutureTheme;